document.addEventListener('DOMContentLoaded', () => {
  // 1. 获取需要的 DOM 元素
  const triggerButton = document.querySelector('.product--block-heading-click');
  const closeButton = document.querySelector('.product--block-heading-popup-icon');
  const popup = document.querySelector('.product--block-heading-popup-bg');

  // 安全检查：确保页面上存在这些元素
  if (!triggerButton || !closeButton || !popup) return;

  // 2. 点击触发区域：显示弹窗
  triggerButton.addEventListener('click', (event) => {
    // 阻止点击事件冒泡，防止触发潜在的父级点击事件
    event.stopPropagation(); 
    
    popup.style.display = 'flex';
  });

  // 3. 点击关闭图标：隐藏弹窗
  closeButton.addEventListener('click', (event) => {
    // 必须阻止冒泡！否则会触发外层 triggerButton 的点击事件，导致弹窗又被打开
    event.stopPropagation(); 
    
    popup.style.display = 'none';
  });
});